import { Component, inject, OnInit } from '@angular/core'
import { SsoService } from '../../../core/services/sso.service'
import { QRCodeComponent } from 'angularx-qrcode'
import { InputOtpModule } from 'primeng/inputotp'
import { Router } from '@angular/router'
import { MfaForm } from '../../../models/form.model'
import { FormsModule } from '@angular/forms'
import { Message } from 'primeng/message'
import { GatewayError } from '../../../models/gateway.model'
import { User } from '../../../models/user.model'
import { SessionService } from '../../../core/security/session.service';
import { LoggerService } from '@danangelus/ngx-app-core';

const log = LoggerService.get("EnrollAuthAppComponent")

@Component({
    selector: 'app-enroll-auth-app',
    standalone: true,
    imports: [
        QRCodeComponent,
        InputOtpModule,
        FormsModule,
        Message
    ],
    templateUrl: './enroll-auth-app.component.html',
    styleUrl: './enroll-auth-app.component.sass'
})
export class EnrollAuthAppComponent implements OnInit {

    private sessionService = inject(SessionService)
    private ssoService = inject(SsoService)
    private router = inject(Router)

    success = false
    uriCopied = false
    // @ts-expect-error See ngOnInit
    otpURI: string

    form: MfaForm | undefined
    displayQR = true

    async ngOnInit() {
        this.form = { code: '', errors: {} }
        this.otpURI = await this.getTotpConnectionString()
    }

    async submit() {
        this.form!.errors.code = ''
        const user = await this.ssoService.checkMfaCode(this.form!.code!,'totp',true)
        if (user instanceof User && user.verified) {
            log.info('submit', 'MfaCode correct. Navigating to homepage')
            this.success = true
            this.sessionService.userVerified(new User(user!))
            setTimeout(() => this.router.navigate(['/home']), 2000)
        } else {
            this.form!.errors.code = 'INVALID_CODE'
        }

    }

    copyCode() {
        navigator.clipboard.writeText(this.otpURI)
            .then(() => {
                this.uriCopied = true
                setTimeout(() => {
                    this.uriCopied = false
                }, 1000)
            })
    }

    private async getTotpConnectionString() {
        const response = await this.ssoService.getTotpCode()
        if (response instanceof GatewayError) {
            this.form!.errors.code = 'INTERNAL_SERVER'
            return ''
        } else {
            return response
        }
    }

}
